import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

export const useResponsiveBp = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down(767.98));

  const isTablet = useMediaQuery(theme.breakpoints.up(768));

  const isDesktop = useMediaQuery(theme.breakpoints.up(1200));

  const isLargeDesktop = useMediaQuery(theme.breakpoints.up(2000));

  return { isMobile, isTablet, isDesktop, isLargeDesktop };
};
